import React, {useState, useContext} from "react";
import './UserDashboard.css';
import Sidebar from './Sidebar/Sidebar';
import ProfileTabContent from './ProfileTabContent.js';
import ChangePassword from "./ChangePassword/ChangePassword";
import LogOut from "./LogOut/LogOut";
import {Lock, Power, User, ClipboardList} from "lucide-react";
import {useTranslation} from "react-i18next";
import LanguageContext from '../../../context/LanguageContext';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';

function UserDashboard() {
    const { dir } = useContext(LanguageContext);
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const showTrackOrdersLinks = (process.env.REACT_APP_SHOW_TRACK_ORDERS_LINKS || 'false').toLowerCase() === 'true';
    const showMyOrdersLinks = (process.env.REACT_APP_SHOW_MY_ORDERS_LINKS || 'false').toLowerCase() === 'true';

    const [activeTab, setActiveTab] = useState('profile');

    const tabs = [
        { id: 'profile', label: t('profilePage.editProfile'), icon: User },
        ...(showTrackOrdersLinks ? [{ id: 'trackOrders', label: t('profilePage.trackOrders'), icon: ClipboardList, isLink: true, path: `/${lang}/track-order` }] : []),
        ...(showMyOrdersLinks ? [{ id: 'myOrders', label: t('profilePage.myOrders'), icon: ClipboardList, isLink: true, path: `/${lang}/my-orders` }] : []),
        { id: 'password', label: t('profilePage.changePassword'), icon: Lock },
        { id: 'logout', label: t('profilePage.logout'), icon: Power },
    ];

    return (
        <main className="main">
            <Breadcrumb title={t('nav.setting')} />

            <section className="profile-page">
                <div className="container profile-page-inner" dir={dir()}>
                    <div className="profile-container">
                        <Sidebar
                            tabs={tabs}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            navAriaLabel={t('nav.setting')}
                        />

                        <div className="profile-content">
                            {activeTab === 'profile' && <ProfileTabContent />}

                            {activeTab === 'password' && <ChangePassword />}

                            {activeTab === 'logout' && <LogOut setActiveTab={setActiveTab} />}
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default UserDashboard;
